import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row items-start justify-between" }
const _hoisted_2 = { class: "q-my-none" }
const _hoisted_3 = { class: "q-my-none text-subtitle" }

import { onMounted, onUnmounted, ref } from 'vue';
import { useYandexMaps } from '@/utils/useYandexMaps';

declare global {
  interface Window {
    ymaps: any
  }
}

interface Props {
  name: string
  address: string
  buildingCoords: [number, number]
  entranceCoords?: [number, number] | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CenterMap',
  props: {
    name: {},
    address: {},
    buildingCoords: {},
    entranceCoords: {}
  },
  setup(__props: any) {

const props = __props;

const mapEl = ref<HTMLElement | null>(null);
let map: any = null;

const { load } = useYandexMaps();

onMounted(async () => {
  await load();

  window.ymaps.ready(() => {
    map = new window.ymaps.Map(mapEl.value, {
      center: props.buildingCoords,
      zoom: 16,
      controls: ['zoomControl', 'geolocationControl'],
    });

    const clusterer = new window.ymaps.Clusterer();

    const buildingPlacemark = new window.ymaps.Placemark(
      props.buildingCoords,
      {
        balloonContent: `
          <strong>${props.name}</strong><br/>
          ${props.address}<br/><br/>
          ${props.entranceCoords
    ? '<button id="route-btn">Построить маршрут до входа</button>'
    : '<button id="route-btn">Построить маршрут</button>'
}
        `,
      },
      {
        preset: 'islands#greenMedicalIcon',
      },
    );

    let entrancePlacemark: any = null;

    if (props.entranceCoords) {
      entrancePlacemark = new window.ymaps.Placemark(
        props.entranceCoords,
        {
          balloonContent: `<strong>Вход в ${props.name}</strong>`,
        },
        {
          preset: 'islands#blueCircleDotIcon',
        },
      );

      clusterer.add(entrancePlacemark);
    }

    clusterer.add(buildingPlacemark);
    map.geoObjects.add(clusterer);

    buildingPlacemark.events.add('balloonopen', () => {
      const btn = document.getElementById('route-btn');

      if (btn) {
        btn.onclick = () => {
          window.ymaps.geolocation.get().then((res: any) => {
            const userCoords = res.geoObjects.position;

            const targetCoords = props.entranceCoords ?? props.buildingCoords;

            const route = new window.ymaps.multiRouter.MultiRoute({
              referencePoints: [userCoords, targetCoords],
              params: {
                routingMode: 'auto',
              },
            });

            map.geoObjects.add(route);
          });
        };
      }
    });
  });
});

onUnmounted(() => {
  if (map) {
    map.destroy();
    map = null;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("h6", _hoisted_2, _toDisplayString(props.name), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(props.address), 1)
      ]),
      _createVNode(_component_q_btn, {
        flat: "",
        dense: "",
        icon: "location_on",
        color: "primary"
      })
    ]),
    _createElementVNode("div", {
      ref_key: "mapEl",
      ref: mapEl,
      class: "map"
    }, null, 512)
  ], 64))
}
}

})